import devConfig from './config.dev';
import prodConfig from './config.prod';
import stageConfig from './config.dev';

export const env = process.env.REACT_APP_ENVIRONMENT;

let actualConfig: KeyValue<string>;
switch (env) {
  case 'stage':
    actualConfig = stageConfig;
    break;
  case 'prod':
    actualConfig = prodConfig;
    break;
  case 'dev':
  default:
    actualConfig = devConfig;
}

export default actualConfig;
